import { Inbox } from 'lucide-react'
import { cn } from '../../lib/utils'

export interface EmptyProps {
  title: string
  hint?: string
  icon?: React.ComponentType<{ className?: string; size?: number | string }>
  className?: string
}

export function Empty({ title, hint, icon: Icon = Inbox, className }: EmptyProps) {
  return (
    <div className={cn('text-ink-3 px-9 py-9 text-center', className)}>
      <Icon className="text-ink-4 mx-auto" size={20} />
      <div className="text-ink-2 mt-2 font-medium">{title}</div>
      {hint && <div className="mt-1 text-12">{hint}</div>}
    </div>
  )
}
